import logo from "./logo.svg";
import "./App.css";
import ChatBot from "./components/Chatbot";

function App() {
  return <ChatBot />;
}

export default App;
